const theme = {
  colors: {
    azul: '#132849',
    amarelo: '#D5912B',
    ouro: '#9F865A',
    offwhite: '#F8F4EA'
  }
};

export default theme;
